import { post } from './axios.js'

/**
 * 로그인 - /user/login
 * @param {Object} params
 * @property {string} params.user_id - 아이디
 * @property {string} params.pswd - 비밀번호
 * @returns
 */
export async function login(params = {}) {
  try {
    const result = await post('/user/login', params)
    return result.data
  } catch(e) {
    /**
     * 0020 : 5회 이상 비밀번호 틀림
     * 0003 : 아이디가 존재하지 않음
     * 0010 : 아이디는 존재하나 비밀번호가 틀림
     */
    if(e.response.data.code === '0020' || e.response.data.code === '0003' || e.response.data.code === '0011'){
      alert(`${e.response.data.ex_message}`)
    }else if(e.response.data.code === '0010'){
      alert('비밀번호를 다시 입력해주세요')
    }else{
      alert('로그인에 실패했습니다.')
    }

    throw new Error(e)

  }
}

/**
 * 마이페이지 비밀번호 변경  - /user/userPasswordChange
 * @param {object} params
 * @property {String} params.old_passwd 기존 비밀번호
 * @property {String} params.new_passwd 새로운(변경할) 비밀번호
 * @property {String} params.user_id id
 * @returns
 */
export async function userPasswordChange(params = {}) {
  try {
    const result = await post('/user/userPasswordChange',params)
    return result.data
  } catch(e) {
    if(e.response.data.code === '0003' || e.response.data.code === '0011'){
      alert(`${e.response.data.ex_message}`)
    }else{
      alert('비밀번호 변경에 실패했습니다.')
    }
    throw new Error(e)
  }
}

/**
 * 관리자 > 비밀번호 변경  - /user/passwordChange
 * @param {object} params
 * @property {String} params.new_passwd 새로운(변경할) 비밀번호
 * @property {String} params.user_id id
 * @returns
 */
export async function passwordChange(params = {}) {
  try {
    const result = await post('/user/passwordChange',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}



/**
 * 아이디 찾기  - /user/userIdFind
 * @param {object} params
 * @property {String} params.email 가입 이메일 주소
 * @property {String} params.user_nm 유저 이름
 * @returns
 */
export async function userIdFind(params = {}) {
  try {
    const result = await post('/user/userIdFind',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}



/**
 * 비밀번호 찾기  - /user/userPasswordFind
 * @param {object} params
 * @property {String} params.email 가입 이메일 주소
 * @property {String} params.user_nm 유저 이름
 * @property {String} params.user_id id
 * @returns
 */
export async function userPasswordFind(params = {}) {
  try {
    const result = await post('/user/userPasswordFind',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

